<template>
    <div class="mb-10 mb-md-20 mb-lg-28">
        <v-row align="center">
            <v-col cols="12" md="" class="mb-10 mb-lg-0">
                <v-badge floating dot>
                    <h4 class="main-tit">{{ title }}</h4>
                </v-badge>
            </v-col>
        </v-row>
    </div>
</template>

<script>
export default {
    props: {
        title: { type: String },
    },
};
</script>
